import React from 'react';
import ActivityPlayButtonOverlay from '../../components/ActivityPlayButtonOverlay';
import useGameInstructions from 'state/hooks/use-game-instructions';
import useOverlay from '@monorepo/shared/src/hooks/use-overlay';

const SharedActivityPlayButton: React.FC = () => {
  const { playSounds } = useGameInstructions();
  const [{ showOverlay }, { setShowOverlay }] = useOverlay();

  const onActivityButtonClick = () => {
    setShowOverlay(false);
    playSounds();
  };

  return <>{showOverlay && <ActivityPlayButtonOverlay onOverlayClick={onActivityButtonClick} />}</>;
};

export default SharedActivityPlayButton;
